import React from 'react';
import PropTypes from 'prop-types';
import { MinusIcon, PlusIcon } from '@heroicons/react/outline';
import { languages } from 'countries-list';
import { supportedLanguages } from '../../utils/i18next';
import Select from '../Select';

const FormFieldMultiLanguage = ({
  language,
  onSelectLanguage,
  languagesValues,
}) => {
  const languageOptions = supportedLanguages.map((lng) => {
    const lngValue = languagesValues?.[lng];

    return {
      value: lng,
      short: languages[lng] ? languages[lng].native : lng,
      label: `${languages[lng] ? languages[lng].native : lng}`,
      icon: lngValue ? <PlusIcon className="text-success" /> : <MinusIcon />,
    };
  });

  return (
    <Select
      options={languageOptions}
      value={language}
      onChange={onSelectLanguage}
    />
  );
};

FormFieldMultiLanguage.propTypes = {};

export default FormFieldMultiLanguage;
